import VehicleTaskForm from './VehicleTaskForm';

/** IAD — Vehicle storage decisions (settlement) */
export default function Frame56() {
  return <VehicleTaskForm taskKind="storage" />;
}
